module.exports = __webpack_public_path__ + "static/media/astro-sprite.691a3e67.png";